import ErrorPage from "next/error"
import { useRouter } from "next/router"
import { H1 } from "../../components"
import Body from "../../components/body/body"
import LearnMore from "../../components/landing/learnMore"
import { formatDate } from "../../utils/formatDate"

export default function Post({ post, posts }) {
	const isRevision = false

	const router = useRouter()

	const morePosts = posts?.edges

	if (router.isFallback && !post?.slug) {
		return <ErrorPage statusCode={404} />
	}

	return (
		<Body subtitle="Blog" subtitleLink="/blog">
			{router.isFallback ? (
				<H1>Loading…</H1>
			) : (
				<>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
						}}
					>
						<h1 className="text-3xl font-semibold mt-10 mb-5">{post.title}</h1>

						<div className="bg-flowy rounded-full relative p-1">
							<video
								muted
								autoPlay
								loop
								playsInline
								className="bg-white rounded-full border-2 border-white w-14 h-14"
								style={{
									boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.25)",
								}}
								poster={`/assets/images/${post.author.node.firstName.toLowerCase()}.jpg`}
							>
								<source
									src={`/assets/videos/${post.author.node.firstName.toLowerCase()}.mp4`}
									type="video/mp4"
								/>
							</video>
						</div>
						<p className="text-base mt-4 text-gray-500">
							{post.author.node.firstName} {post.author.node.lastName}
							{post.author.node.description && ","}{" "}
							{post.author.node.description}
						</p>
						<p className="text-base text-gray-500">{formatDate(post.date)}</p>
					</div>

					<img
						src={post.featuredImage.node.sourceUrl}
						className="mt-4 mb-10"
						alt=""
					/>

					<div
						dangerouslySetInnerHTML={{ __html: post.content }}
						className="prose self-center mb-40"
					/>

					<LearnMore />
				</>
			)}
		</Body>
	)

	// if (!router.isFallback && !post?.slug) {
	// 	return <ErrorPage statusCode={404} />
	// }

	// return (
	// 	<Layout preview={preview}>
	// 		<Container>
	// 			<Header />
	// 			{router.isFallback ? (
	// 				<PostTitle>Loading…</PostTitle>
	// 			) : (
	// 				<>
	// 					<article>
	// 						<Head>
	// 							<title>
	// 								{post.title} | Next.js Blog Example with {CMS_NAME}
	// 							</title>
	// 							<meta
	// 								property="og:image"
	// 								content={post.featuredImage?.node?.sourceUrl}
	// 							/>
	// 						</Head>
	// 						<PostHeader
	// 							title={post.title}
	// 							coverImage={post.featuredImage?.node}
	// 							date={post.date}
	// 							author={post.author?.node}
	// 							categories={post.categories}
	// 						/>
	// 						<PostBody content={post.content} />
	// 						<footer>
	// 							{post.tags.edges.length > 0 && <Tags tags={post.tags} />}
	// 						</footer>
	// 					</article>

	// 					<SectionSeparator />
	// 					{morePosts.length > 0 && <MoreStories posts={morePosts} />}
	// 				</>
	// 			)}
	// 		</Container>
	// 	</Layout>
	// )
}

export async function getStaticProps({ params, preview = false }) {
	// const data = await getPostAndMorePosts(params.post, false, previewData)

	const howToSetup = {
		post: {
			title: "How to set up your Space",
			excerpt:
				"<p>How to setup your personal SaySom Space To create your personal SaySom event, you must first register on SaySom. After your registration, you can create your own free Space.&nbsp; Creating a Space is still as simple as it could be, just hit the &#8220;Create Space&#8221; button on our website, give your Space a logo and [&hellip;]</p>\n",
			slug: "how-to-set-up-your-space",
			date: "2021-07-28T12:26:01",
			featuredImage: {
				node: {
					sourceUrl:
						"https://blog.saysom.app/wp-content/uploads/2021/07/Pharma.png",
				},
			},
			author: {
				node: {
					name: "Antonia Pervanidis",
					firstName: "Antonia",
					lastName: "Pervanidis",
					avatar: {
						url:
							"https://secure.gravatar.com/avatar/d93647adf8f6f3c902c99a31ec36c23b?s=96&d=mm&r=g",
					},
					description: "Co-founder",
				},
			},
			categories: { edges: [{ node: { name: "Uncategorized" } }] },
			tags: { edges: [] },
			content:
				'\n<p>How to setup your personal <a href="https://saysom.app/space" data-type="URL" data-id="https://saysom.app/space" target="_blank" rel="noreferrer noopener">SaySom Space</a></p>\n\n\n\n<div class="wp-block-media-text alignwide is-stacked-on-mobile" style="grid-template-columns:30% auto"><figure class="wp-block-media-text__media"><img loading="lazy" width="1024" height="371" src="https://blog.saysom.app/wp-content/uploads/2021/07/Bildschirmfoto-2021-07-27-um-18.21.50-1024x371.png" alt="" class="wp-image-32 size-full" srcset="https://blog.saysom.app/wp-content/uploads/2021/07/Bildschirmfoto-2021-07-27-um-18.21.50-1024x371.png 1024w, https://blog.saysom.app/wp-content/uploads/2021/07/Bildschirmfoto-2021-07-27-um-18.21.50-300x109.png 300w, https://blog.saysom.app/wp-content/uploads/2021/07/Bildschirmfoto-2021-07-27-um-18.21.50-768x278.png 768w, https://blog.saysom.app/wp-content/uploads/2021/07/Bildschirmfoto-2021-07-27-um-18.21.50-1200x435.png 1200w, https://blog.saysom.app/wp-content/uploads/2021/07/Bildschirmfoto-2021-07-27-um-18.21.50.png 1236w" sizes="(max-width: 1024px) 100vw, 1024px" /></figure><div class="wp-block-media-text__content">\n<p>To create your personal SaySom event, you must first <a rel="noreferrer noopener" href="https://saysom.app/register" data-type="URL" data-id="https://saysom.app/register" target="_blank">register</a> on SaySom. After your registration, you can create your own free Space.&nbsp;</p>\n\n\n\n<p>Creating a Space is still as simple as it could be, just hit the &#8220;Create Space&#8221; button on our website, give your Space a logo and title, click “Create Space” and you are ready to network.</p>\n\n\n\n<p><meta charset="utf-8"></p>\n\n\n\n<p><br></p>\n</div></div>\n\n\n\n<div class="wp-block-media-text alignwide is-stacked-on-mobile" style="grid-template-columns:19% auto"><figure class="wp-block-media-text__media"><img loading="lazy" width="715" height="1024" src="https://blog.saysom.app/wp-content/uploads/2021/07/Bildschirmfoto-2021-07-20-um-11.50.13-715x1024.png" alt="" class="wp-image-29 size-full" srcset="https://blog.saysom.app/wp-content/uploads/2021/07/Bildschirmfoto-2021-07-20-um-11.50.13-715x1024.png 715w, https://blog.saysom.app/wp-content/uploads/2021/07/Bildschirmfoto-2021-07-20-um-11.50.13-210x300.png 210w, https://blog.saysom.app/wp-content/uploads/2021/07/Bildschirmfoto-2021-07-20-um-11.50.13-768x1100.png 768w, https://blog.saysom.app/wp-content/uploads/2021/07/Bildschirmfoto-2021-07-20-um-11.50.13.png 908w" sizes="(max-width: 715px) 100vw, 715px" /></figure><div class="wp-block-media-text__content">\n<p>One of the main features of SaySom is that you can design your space according to your wishes. Your room still looks a bit empty and you want to bring more life into it? Open up the edit Area menu on the right-hand side by clicking on the black rectangle under the games menu icon. On the top, you will find options to change the space name, colors, or logo. You can even adjust the moderator color here. Below you will find the Areas section. Hit the + button to create a new Area or click the edit button to change the settings for an existing Area. After changing some settings, do not forget to hit the “save” button to make the changes visible and permanent for all users.</p>\n</div></div>\n\n\n\n<div class="wp-block-media-text alignwide has-media-on-the-right is-stacked-on-mobile" style="grid-template-columns:auto 19%"><figure class="wp-block-media-text__media"><img loading="lazy" width="882" height="1296" src="https://blog.saysom.app/wp-content/uploads/2021/07/Bildschirmfoto-2021-07-20-um-11.52.00.png" alt="" class="wp-image-30 size-full" srcset="https://blog.saysom.app/wp-content/uploads/2021/07/Bildschirmfoto-2021-07-20-um-11.52.00.png 882w, https://blog.saysom.app/wp-content/uploads/2021/07/Bildschirmfoto-2021-07-20-um-11.52.00-204x300.png 204w, https://blog.saysom.app/wp-content/uploads/2021/07/Bildschirmfoto-2021-07-20-um-11.52.00-697x1024.png 697w, https://blog.saysom.app/wp-content/uploads/2021/07/Bildschirmfoto-2021-07-20-um-11.52.00-768x1128.png 768w" sizes="(max-width: 882px) 100vw, 882px" /></figure><div class="wp-block-media-text__content">\n<p>Once you created the Area you will see the settings panel for your new area. Here you can adjust its label, size, position, and even the content. Want to upload a picture, let your attendees have some fun, or just pick a color for your Area? Just search for the appropriate content in the list and upload the desired content. After setting up your Area do not forget to hit the “save&#8221; button. </p>\n\n\n\n<p></p>\n</div></div>\n\n\n\n<div class="wp-block-columns alignwide">\n<div class="wp-block-column" style="flex-basis:50%">\n<p><strong>Keep in mind</strong></p>\n\n\n\n<p>When adding images to your Area we recommend keeping the same ratio in size for your Area as your image.&nbsp;</p>\n\n\n\n<p>When lowering the X value, the Area will move to the left-hand side. When lowering the Y value, the Area will move downwards.</p>\n</div>\n</div>\n\n\n\n<p></p>\n',
		},
		posts: {
			edges: [
				{
					node: {
						title: "How to use SaySom",
						excerpt:
							"<p>Let’s bring people back together. Preperation Use SaySom in Chrome &#8211; trust me it, works best Make sure you don&#8217;t use your camera and microphone for any other system, or we won&#8217;t be able to access them. It&#8217;s best to leave third-party systems like Zoom or Microsoft Teams in advance. If possible, turn off your [&hellip;]</p>\n",
						slug: "how-to-use-saysom",
						date: "2021-06-15T13:58:01",
						featuredImage: {
							node: {
								sourceUrl:
									"https://blog.saysom.app/wp-content/uploads/2021/06/Gründermotor.png",
							},
						},
						author: {
							node: {
								name: "Antonia Pervanidis",
								firstName: "Antonia",
								lastName: "Pervanidis",
								avatar: {
									url:
										"https://secure.gravatar.com/avatar/d93647adf8f6f3c902c99a31ec36c23b?s=96&d=mm&r=g",
								},
								description: "Co-founder",
							},
						},
						categories: { edges: [{ node: { name: "Uncategorized" } }] },
						tags: { edges: [] },
					},
				},
			],
		},
	}
	const howToUse = {
		post: {
			title: "How to use SaySom",
			excerpt:
				"<p>Let’s bring people back together. Preperation Use SaySom in Chrome &#8211; trust me it, works best Make sure you don&#8217;t use your camera and microphone for any other system, or we won&#8217;t be able to access them. It&#8217;s best to leave third-party systems like Zoom or Microsoft Teams in advance. If possible, turn off your [&hellip;]</p>\n",
			slug: "how-to-use-saysom",
			date: "2021-06-15T13:58:01",
			featuredImage: {
				node: {
					sourceUrl:
						"https://blog.saysom.app/wp-content/uploads/2021/06/Gründermotor.png",
				},
			},
			author: {
				node: {
					name: "Antonia Pervanidis",
					firstName: "Antonia",
					lastName: "Pervanidis",
					avatar: {
						url:
							"https://secure.gravatar.com/avatar/d93647adf8f6f3c902c99a31ec36c23b?s=96&d=mm&r=g",
					},
					description: "Co-founder",
				},
			},
			categories: { edges: [{ node: { name: "Uncategorized" } }] },
			tags: { edges: [] },
			content:
				'\n<p>Let’s bring people back together.</p>\n\n\n\n<h4>Preperation</h4>\n\n\n\n<ul><li>Use SaySom in Chrome &#8211; trust me it, works best</li><li>Make sure you don&#8217;t use your camera and microphone for any other system, or we won&#8217;t be able to access them. It&#8217;s best to leave third-party systems like Zoom or Microsoft Teams in advance.</li><li>If possible, turn off your firewall</li></ul>\n\n\n\n<h4>Join the space</h4>\n\n\n\n<ul><li>You can join the space by clicking the &#8220;Join&#8221; button or by tearing the ticket from top to bottom</li><li>Please enter your name. Your name will be visible to other participants</li><li>To access your camera and microphone we need your permission. This will allow other participants to see and hear you</li><li>Click the &#8220;join&#8221; button to join the room.</li></ul>\n\n\n\n<h3 class="has-text-align-center">Happy networking</h3>\n\n\n\n<p></p>\n',
		},
		posts: {
			edges: [
				{
					node: {
						title: "How to set up your Space",
						excerpt:
							"<p>How to setup your personal SaySom Space To create your personal SaySom event, you must first register on SaySom. After your registration, you can create your own free Space.&nbsp; Creating a Space is still as simple as it could be, just hit the &#8220;Create Space&#8221; button on our website, give your Space a logo and [&hellip;]</p>\n",
						slug: "how-to-set-up-your-space",
						date: "2021-07-28T12:26:01",
						featuredImage: {
							node: {
								sourceUrl:
									"https://blog.saysom.app/wp-content/uploads/2021/07/Pharma.png",
							},
						},
						author: {
							node: {
								name: "Antonia Pervanidis",
								firstName: "Antonia",
								lastName: "Pervanidis",
								avatar: {
									url:
										"https://secure.gravatar.com/avatar/d93647adf8f6f3c902c99a31ec36c23b?s=96&d=mm&r=g",
								},
								description: "Co-founder",
							},
						},
						categories: { edges: [{ node: { name: "Uncategorized" } }] },
						tags: { edges: [] },
					},
				},
			],
		},
	}

	type WordPressData = typeof howToSetup

	let fetchedData: WordPressData | undefined = undefined

	if (params.post === "how-to-use-saysom") {
		fetchedData = howToUse
	} else if (params.post === "how-to-set-up-your-space") {
		fetchedData = howToSetup
	}

	if (!fetchedData) {
		return { notFound: true }
	}

	return {
		props: {
			preview,
			post: fetchedData ? fetchedData.post : null,
			posts: fetchedData ? fetchedData.posts : null,
		},
	}
}

export async function getStaticPaths() {
	// const allPosts = await getAllPostsWithSlug()

	const fetchedAllPosts = {
		edges: [
			{ node: { slug: "how-to-set-up-your-space" } },
			{ node: { slug: "how-to-use-saysom" } },
		],
	}

	return {
		paths: fetchedAllPosts.edges.map(({ node }) => `/blog/${node.slug}`) || [],
		fallback: true,
	}
}
